"use client";
import useMobileDetect from "@/hooks/useMobileDetect";
import { useEffect, useRef, useState } from "react";
import Image from "next/image";
import { handleCardClick } from "@/utils/tools";
import ImageWithSkeleton from "@/app/components/common/ImageWithSkeleton";

type mediaCardListProps = {
  isFirstMobile?: boolean,
  list: {
    "name": string,
    "h5_pic": string,
    "pc_pic": string,
    "alt_text": string,
    "link_type"?: number,
    "link"?: string,
    "open_type"?: number,
  }[],
  title?: string
}
export const TenPicturesText: React.FC<mediaCardListProps> = ({ isFirstMobile, list, title }) => {

  const isMobile = useMobileDetect(isFirstMobile);

  const _renderPcCardContent = () => {
    return (
      <div className="grid grid-cols-5 gap-x-16 gap-y-40" key="pcCardContent">
        {
          list?.map((item, index: number) => {
            return handleCardClick({...item, idx: index}, (
              <div
                key={"pcCardItem" + index}
              >
                {item?.pc_pic && (
                  // <Image
                  //   style={{ width: '100%', height: 'auto' }}
                  //   width={100}
                  //   height={100}
                  //   src={
                  //     process.env.NEXT_PUBLIC_IMAGE_URL + item?.pc_pic
                  //   }
                  //   alt={item?.alt_text}
                  //   className="rounded-sm ant-skeleton-image-self"
                  // />
                  <div className="relative w-full aspect-square pt-[100%]">
                    <ImageWithSkeleton
                      src={process.env.NEXT_PUBLIC_IMAGE_URL + item?.pc_pic}
                      alt={item?.alt_text}
                      width={100}
                      height={100}
                      className="rounded-sm"
                    />
                  </div>
                )}
                <h2 className="leading-24 text-bravve-100 mt-16 text-lg">
                  {item?.name}
                </h2>
              </div>
            ), isMobile)
          })
        }
      </div>
    );
  };

  const _renderMobileCardContent = () => {
    return (
      <div className="grid grid-cols-2 gap-x-22 gap-y-24" key="mobileCardContent">
        {
          list?.map((item, index: number) => {
            return handleCardClick({...item, idx: index}, (
              <div
                key={"mobileCardItem" + index}
                className="flex items-center"
              >
                {item?.h5_pic && (
                  // <Image
                  //   style={{ width: 42, height: 'auto' }}
                  //   width={100}
                  //   height={100}
                  //   src={process.env.NEXT_PUBLIC_IMAGE_URL + item?.h5_pic}
                  //   className="rounded-sm ant-skeleton-image-self"
                  //   alt={item?.alt_text}
                  // />
                  <div className="relative w-42 h-42">
                    <ImageWithSkeleton
                      src={process.env.NEXT_PUBLIC_IMAGE_URL + item?.h5_pic}
                      alt={item?.alt_text}
                      width={100}
                      height={100}
                      className="rounded-sm"
                    />
                  </div>
                )}
                <div
                  className="leading-20 text-bravve-100 ml-8 text-lg"
                >
                  {item?.name}
                </div>
              </div>
            ), isMobile)
          })}
      </div>
    );
  };


  return <div
    style={{
      marginBottom: isMobile ? 24 : 36,
    }}
    className="mx-20 md:mx-40"
    key="tenPicturesText"
  >
    {
      title ?
      <div
        key="tenPicturesTextTitle"
        className="font-bold text-bravve-100"
        style={{
          fontSize: isMobile ? 22 : 28,
          lineHeight: isMobile ? '30px' : '32px',
          marginBottom: isMobile ? 24 : 56,
        }}
      >
        {title}
      </div>
      :
      null
    }
    {isMobile ? <div key="mobileTenPicturesText">{_renderMobileCardContent()}</div> : <div key="pcTenPicturesText">{_renderPcCardContent()}</div>}
  </div>
}